import { InjectionToken, WritableSignal } from '@angular/core';
import { UserFormat } from '../interfaces/user-format.interface';

export const USER_FORMAT = new InjectionToken<WritableSignal<UserFormat>>('UserFormat');
